import { IMAContactDetails } from "../types/MAContactDetails";

export const initialMaContactOverview: IMAContactDetails = {
    FirstName: "",
    LastName: "",
    Linkedin: "",
    Email: "",
    PhoneNumber: ""
};